import type { ReactNode } from 'react';
import { AgentPanel } from '@agent-panel/index';
import { IncidentDrawer } from '@incidents/widgets/incident-drawer';
import { NotificationsProvider } from '@notifications/entities/notification';
import { NotificationDrawer } from '@notifications/widgets/notification-drawer';
import { SupportDrawer } from '@support/widgets/support-drawer';
import { TaskDrawer } from '@task-manager/widgets/task-drawer';
import { useSidebarStore } from '@/shared/model/use-sidebar-store';
import { Text } from '@/shared/ui';
import css from './app-layout.module.scss';
import { MobileHeader } from './mobile-header';
import { Sidebar } from './sidebar';
import { TopBar } from './top-bar';

type AppLayoutProps = {
  activeItem?: string;
  breadcrumbs: string[];
  children: ReactNode;
};

export const AppLayout = ({
  activeItem,
  breadcrumbs,
  children,
}: AppLayoutProps) => {
  const { collapsed, toggle, setCollapsed } = useSidebarStore();

  return (
    <NotificationsProvider>
      <div className={css.root}>
        <Sidebar
          activeItem={activeItem}
          collapsed={collapsed}
          onToggle={toggle}
        />
        {!collapsed && (
          <button
            aria-label="Close sidebar"
            className={css.overlay}
            onClick={() => setCollapsed(true)}
            type="button"
          />
        )}
        <div className={css.body}>
          <MobileHeader onMenuToggle={() => setCollapsed(false)} />
          <TopBar breadcrumbs={breadcrumbs} onToggleSidebar={toggle} />
          <main className={css.main}>{children}</main>
        </div>
        <AgentPanel title="Agent">
          <Text size="sm" variant="muted">
            Open this panel from a page that supports the agent (e.g. an
            itinerary) to get suggestions or run commands.
          </Text>
        </AgentPanel>
        <TaskDrawer />
        <IncidentDrawer />
        <SupportDrawer />
        <NotificationDrawer />
      </div>
    </NotificationsProvider>
  );
};
